
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class QueueGrid extends SiteEntityGrid<QueueRow, any> {
        protected getColumnsKey() { return 'Workflow.Queue'; }
        protected getDialogType() { return QueueDialog; }
        protected getIdProperty() { return QueueRow.idProperty; }
        protected getLocalTextPrefix() { return QueueRow.localTextPrefix; }
        protected getService() { return QueueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}